import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import { getAppUrl } from "../../map_v6/components/BrandDetails";
import { Employee } from "../types";

export const managersApi = createApi({
  reducerPath: "managersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${getAppUrl()}api/v6/managers/`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState)?.user?.user?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLocations: builder.query<
      { locations: any[] },
      { type: string; value: string }
    >({
      query: (query) =>
        `locations?${query.type}=${encodeURIComponent(query.value)}`,
    }),
    getGuestDetails: builder.query<any, { userId: string; locationId: string }>(
      {
        query: ({ userId, locationId }) =>
          `users/${userId}?location_id=${locationId}`,
        keepUnusedDataFor: 0, // Don't cache data - force fresh fetch every time
      },
    ),
    getGuests: builder.query<{ users: any[] }, string>({
      query: (query) => `users?query=${encodeURIComponent(query)}`,
      keepUnusedDataFor: 0, // Don't cache data - force fresh fetch every time
    }),
    getLocationTransactions: builder.query<
      { transactions: any[] },
      string | number
    >({
      query: (locationId) => `locations/${locationId}/transactions`,
    }),
    getTicketData: builder.query<
      any,
      { locationId: string | number; ticketNumber: string | number }
    >({
      query: ({ locationId, ticketNumber }) =>
        `locations/${locationId}/tickets/${ticketNumber}`,
      keepUnusedDataFor: 0, // Don't cache data - force fresh fetch every time
    }),
    getLocationEmployees: builder.query<
      { employees: Employee[] },
      string | number
    >({
      query: (locationId) => `locations/${locationId}/employees`,
    }),
    createRefund: builder.mutation<
      any,
      {
        credit_transaction_id: string | number;
        refund_reason: string;
        refund_amount: number;
        refund_notes: string;
        modify_tip: boolean;
      }
    >({
      query: (refundData) => ({
        url: "refunds",
        method: "POST",
        body: refundData,
      }),
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useGetGuestDetailsQuery,
  useGetGuestsQuery,
  useGetLocationTransactionsQuery,
  useGetTicketDataQuery,
  useGetLocationEmployeesQuery,
  useCreateRefundMutation,
} = managersApi;
